/**
 * @author Ariel
 * @description 调查问卷页面配置
 * @Date 2020/3/12
 */
import React from 'react'
import moment from "moment";
import { component_tool } from '../../../tool';
import { WizTableForm } from '@/containers/common'
import QRCode from 'qrcode.react';
import HighSet from '@/containers/common/highSet'

let { WizModal, WizButton } = component_tool;
//配置项
let componentName = 'survey'

const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm') : '';
}
const columns = (data) => {
  return [
    {
      name: "id",
      fromItem: {
        type: "hidden"
      }
    },
    {
      title: "问卷标题",
      name: "title",
      searchItem: {},
      tableItem: { width: 300 }
    },
    {
      title: "问卷类型",
      name: "type",
      searchItem: {
        type: 'select'
      },
      dict: [
        { code: 0, codeName: '普通问卷' },
        // { code: 1, codeName: '随堂问卷' },
        { code: 2, codeName: '回执问卷' },
        { code: 3, codeName: '满意度问卷' },
        // { code: 4, codeName: '直播课堂问卷' }
      ],
      tableItem: {}
    },
    {
      title: "参与人数",
      name: "submitUserNumber",
      tableItem: {}
    },
    {
      title: "问卷时间",
      name: "surveyDate",
      tableItem: {
        width: 300,
        render: (text, record) => {
          const { startDate, endDate } = record;
          let classDate = formatterDate(startDate) + " ~ " + formatterDate(endDate);
          return classDate
        }
      },
    },
    {
      title: "状态",
      name: "status",
      searchItem: {
        type: 'select'
      },
      dict: [
        { code: 0, codeName: '草稿' },
        { code: 1, codeName: '已发布' },
        { code: 2, codeName: '已结束' },
        { code: 3, codeName: '已关闭' }
      ],
      tableItem: {}
    }
  ]
};


this._downSurveyQrCode = () => {
  const canvasImg = document.getElementById('qrCode'); // 获取canvas类型的二维码
  const img = new Image();
  img.src = canvasImg.toDataURL('image/png'); // 将canvas对象转换为图片的data url
  let a_link = document.getElementById('down_link');
  a_link.href = img.src
  a_link.download = '问卷二维码';
};

const templateConfig = (data) => {
  const { self } = data;
  let valueRows = []
  const surveyTempConfig = WizTableForm.Config.surveyTemp(self, { apiParams: { status: 1 } })

  let tableFormProps = {
    title: '选择问卷模版',
    showModal: false,
    visible: true,
    selectType: 'radio',
    width: 900,
    initRows: [],
    value: [],
    onSubmit: self._addSurveyByTempSubmit,
    onCancel: self._onCancelTemp,
  }
  const _renderBtn = (value, valueRowList) => {
    if (value && value > 0) {
      value = value[0]
    }
    valueRows = valueRowList
  }

  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns: columns(data),
        searchBarProps: {
          // buttonSort: ['group', 'delete','export'],
          buttonSort: ['group', 'export'],
          buttons: [
            {
              type: 'group',
              key: 'group',
              params: {
                key: "_group_btn",
                icon: 'down', children: '新增', type: 'primary'
              },
              options: [
                {
                  key: 'createFromTemplate',
                  name: "WizButton",
                  params: {
                    children: '从模版中创建'
                  },
                  customOnClick: {
                    key: "modal",
                    params: {
                      modalParams: {
                        title: "选择问卷模版",
                        diy: (e) => {
                          return <>
                            <WizTableForm   {...surveyTempConfig} {...tableFormProps} renderValue={_renderBtn}>
                            </WizTableForm>
                          </>
                        },
                        onOk: (obj, e) => {
                          self._addSurveyByTempSubmit({ valueRows: valueRows })
                        },
                        onCancel: () => {
                          self._onCancelTemp()
                        },
                        width: 700
                      }
                    }
                  }
                },
                {
                  key: 'createBlankQuestionnaire',
                  custom: true,
                  params: { children: '创建空白问卷' },
                  customOnClick: {
                    key: 'jumpPage',
                    params: {
                      key: 'push',
                      pathname: '/biz/survey/surveyDetailAdd'
                    }
                  }
                }
              ]
            },
            {
              key: 'export',
              custom: true,
              params: { icon: 'export', children: '导出', type: 'export' },
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "exportSurvey",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return { ...filters }
                }
              }
            }
          ]
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: "id",
          selectType: "checkbox",
          isScroll: true,
          bordered: false,
          paging: false,
          loading: false
        },
        // rowOperateSort: ['update', 'preview', 'questionnaireRecord', 'releaseOrClose', 'copyQuestionnaire', 'exportSurvey', 'QRCode', 'advancedSet'],
        rowOperateSort: ['update', 'preview', 'questionnaireRecord', 'releaseOrClose', 'copyQuestionnaire', 'exportSurvey', 'advancedSet'],
        rowOperateView: [
          {
            key: "update",
            custom: true,
            params: { children: "编辑" },
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: "/biz/survey/surveyDetailUpd"
              }
            },
            recordChangeParams: ({ record, rows }) => {
              let disabled = false
              if (record && record['status'] === 2) {
                disabled = true
              }
              return { disabled }
            }
          },
          {
            key: "preview",
            custom: true,
            params: { children: "预览" },
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: "/biz/survey/surveyPreview"
              }
            }
          },
          {
            key: "questionnaireRecord",
            custom: true,
            params: { children: "问卷记录" },
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: "/biz/survey/surveyRecordInfo"
              }
            }
          },
          {
            key: "releaseOrClose",
            custom: true,
            params: { children: "发布" },
            textFormat: {
              recordKey: 'status',
              dirt: { 0: '发布', 2: '发布', 3: '发布', 1: '关闭' }
            },
            customOnClick: {
              key: "action",
              params: {
                apiKey: "enable",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                let newStatus = 1
                if (record && record['status'] && record['status'] === 1) {
                  newStatus = 3
                }
                let content = `您确定要发布该问卷吗？`;
                if (newStatus === 3) {
                  content = `您确定要关闭该问卷吗？`;
                }
                if (newStatus === 1 && !record['questionIds']) {
                  WizModal.confirm({
                    title: '注意',
                    content: '该问卷还未设计题目，不能发布'
                  })
                } else {
                  WizModal.confirm({
                    title: '注意', content,
                    onOk: () => {
                      callback && callback({
                        id: record['id'],
                        status: newStatus,
                      })
                    },
                    onCancel() {
                    }
                  });
                  return null
                }
              }
            },
            recordChangeParams: ({ record, rows }) => {
              let disabled = false
              if (record && record['status'] === 2) {
                disabled = true
              }
              return { disabled }
            }
          },
          {
            key: "copyQuestionnaire",
            custom: true,
            params: { children: "复制问卷" },
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: "/biz/survey/surveyDetailAdd",
                record: { "channelType": "survey" }
              }
            }
          },
          {
            key: "QRCode",
            custom: true,
            params: { children: "二维码" },
            customOnClick: {
              key: 'modal',
              params: {
                modalParams: {
                  title: '问卷二维码',
                  footer: null,
                  destroyOnClose: true,
                  diy: (e) => {
                    return <>
                      <h2 align="center">{e.record.title}</h2>
                      <div align='center' style={{paddingBottom:20}}>
                        <QRCode
                          style={{ margin: 20 }}
                          id="qrCode"
                          value={constants.env.sys_user_url + '/#/mobile/surveyDetail?id=' + e.record.id}
                          fgColor="#000000" // 二维码的颜色
                        />
                        <br />
                        <a style={{ borderRadius: 3, borderWidth: 1, borderStyle: 'solid', borderColor: '#6faff8', padding: 8 }} id='down_link' onClick={this._downSurveyQrCode}>下载二维码</a>
                      </div>
                    </>
                  }
                }
              }
            },
            recordChangeParams: ({ record, rows }) => {
              let disabled = false
              if (record && record['status'] === 0) {
                disabled = true
              }
              return { disabled }
            }
          },
          {
            key: 'advancedSet',
            custom: true,
            params: { children: '高级设置' },
            customOnClick: {
              key: 'modal',
              params: {
                modalParams: {
                  title: '高级设置',
                  bordered: true,
                  footer: null,
                  destroyOnClose: true,
                  diy: (e) => {
                    //BIZ_SURVEY = 2;
                    return <>
                      <HighSet data={{ record: e.record, bizType: 2 }}
                        changeModal={e.changeModal}
                      />
                    </>
                  },
                  width: 950
                },
              }
            },
            recordChangeParams: ({ record, rows }) => {
              let disabled = false
              if (record && record['status'] !== 1) {
                disabled = true
              }
              return { disabled }
            }
          }
        ]
      }
    }
  }
};

const apis = {
  list: {
    path: `${componentName}/list`,
    payload: {
      key: `${componentName}@list`,
      apiParams: {}
    }
  },
  delete: {
    path: `${componentName}/delete`,
    payload: {
      key: `${componentName}@delete`,
      apiParams: {}
    }
  },
  enable: {
    path: `${componentName}/enable`,
    payload: {
      key: `${componentName}@enable`,
      apiParams: {}
    }
  },
  exportSurvey: {
    path: `${componentName}/exportSurvey`,
    payload: {
      key: `${componentName}@exportSurvey`,
      apiParams: {}
    }
  }
}

let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export { reduxTemplateCofig, templateConfig };
